
import React, { useState } from 'react';

interface SaveCollectionDialogProps {
  onClose: () => void;
  onSave: (name: string, isOfficial: boolean) => void;
}

const SaveCollectionDialog: React.FC<SaveCollectionDialogProps> = ({ onClose, onSave }) => {
  const [name, setName] = useState('');
  const [isOfficial, setIsOfficial] = useState(false);

  const handleSave = () => {
    if (name.trim()) {
      onSave(name, isOfficial);
    } else {
      alert('Inserisci un nome per la collezione.');
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-40">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Salva Nuova Collezione</h2>
        <div className="mb-4">
          <label htmlFor="collection-name" className="block text-sm font-medium text-gray-700">
            Nome Collezione
          </label>
          <input
            type="text"
            id="collection-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm bg-white"
            autoFocus
          />
        </div>
        <div className="mb-6">
          <div className="flex items-center">
            <input
              id="is-official"
              type="checkbox"
              checked={isOfficial}
              onChange={(e) => setIsOfficial(e.target.checked)}
              className="h-4 w-4 text-sky-600 border-gray-300 rounded"
            />
            <label htmlFor="is-official" className="ml-2 block text-sm text-gray-900">
              Collezione Ufficiale (es. per agenti)
            </label>
          </div>
        </div>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300"
          >
            Annulla
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-sky-600 text-white rounded-md hover:bg-sky-700"
          >
            Salva Collezione
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveCollectionDialog;